import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './transactions-modal-content.scss';
import { getTransactionItemsAction } from '../../actions/transactionActions';
import { getAcquiringContractAddress } from '../../actions/accountActions';
import { currencyFormat } from '../../utilities/core-utilities';
import { formatDate } from '../../utilities/dayjs-utilities';
import { DataTable } from '@ampol/design-system';
import { DATE_FORMAT } from 'utilities/constants';
import ModalCoreContent from 'components/modal-core-content/modal-core-content';
import { capitalize } from 'lodash';

const Panel = ({ children }) => <div className='p-m bg-background-light'>{children}</div>;

const TransactionsModalContent = ({ item }) => {
  const dispatch = useDispatch();

  const transactionItems = useSelector((state) => state.transactionsStore.transactionItems);
  const isTransactionLoading = useSelector((state) => state.transactionsStore.transactionItemsLoading);
  const acquiringContractAddress = useSelector((state) => state.accountsStore.acquiringContractAddress);
  const acquiringContractAddressLoading = useSelector((state) => state.accountsStore.acquiringContractAddressLoading);

  useEffect(() => {
    dispatch(getTransactionItemsAction(item.contractAndDoc));
    dispatch(getAcquiringContractAddress(item.sourceNumber));
  }, []);

  const transactionDetails = [
    {
      key: 'Transaction date',
      value: formatDate(item.transactionDate, 'DD/MM/YYYY HH:mm:ss'),
    },
    {
      key: 'Card number',
      value: item.cardNumber,
    },
    {
      key: 'Transaction amount',
      value: currencyFormat(item.transactionAmount),
    },
    {
      key: 'Transaction status',
      value: item.transactionStatus,
    },
    {
      key: 'Transaction type',
      value: item.transactionType,
    },
    {
      key: 'Posting date',
      value: formatDate(item.postingDate, DATE_FORMAT),
    },
    {
      key: 'Capture type',
      value: item?.captureType === 'E' ? 'EFT' : item?.captureType,
    },
    {
      key: 'Cost centre',
      value: item.costCentre,
    },
    {
      key: 'Site name',
      value: acquiringContractAddressLoading ? '-' : acquiringContractAddress?.addressName,
    },
    {
      key: 'Phone number',
      value: acquiringContractAddressLoading ? '-' : acquiringContractAddress?.businessPhone,
    },
    {
      key: 'Address',
      value: acquiringContractAddressLoading ? (
        '-'
      ) : (
        <div>
          <div>{acquiringContractAddress?.line2}</div>
          <div>{acquiringContractAddress?.line3}</div>
          <div>{acquiringContractAddress?.line4}</div>
          <div>
            {acquiringContractAddress?.stateCode}, {acquiringContractAddress?.zipCode}
          </div>
        </div>
      ),
    },
  ];

  const driverVehicleDetails = [
    {
      key: 'Driver name',
      value: capitalize(item.driverName),
    },
    {
      key: 'Registration number',
      value: item.registrationNumber,
    },
    {
      key: 'Domestic number',
      value: item.domesticNumber,
    },
    {
      key: 'Odometer',
      value: item.odometer,
    },
  ];

  return (
    <div className={'transaction space-y-m'}>
      <Panel>
        <div className='flex flex-row justify-between align-middle'>
          <h3 className='m-0'>Transaction details</h3>
        </div>
        <ModalCoreContent data={transactionDetails} isLoading={isTransactionLoading} />
      </Panel>

      <Panel>
        <h3 className='m-0'>Driver and vehicle details</h3>
        <div className='mb-m'>
          <ModalCoreContent data={driverVehicleDetails} isLoading={isTransactionLoading} />
        </div>
      </Panel>

      <Panel>
        <h3 className='m-0 mb-2'>Product details</h3>
        <DataTable
          caption={'Product Details'}
          columns={[
            {
              header: 'Description',
              accessorKey: 'goodsItem',
            },
            {
              header: 'Quantity',
              accessorKey: 'quantity',
            },
            {
              header: 'Unit Price',
              accessorKey: 'basePrice',
              rtl: true,
            },
            {
              header: 'GST',
              id: 'vatAmount',
              accessorFn: (x) => currencyFormat(x.vatAmount),
              rtl: true,
            },
            {
              header: 'Customer total inc GST',
              id: 'baseAmount',
              accessorFn: (x) => currencyFormat(x.baseAmount),
              rtl: true,
            },
          ]}
          data={[
            ...transactionItems,
            ...(item.transactionFeeWithTax > 0
              ? [
                  {
                    goodsItem: 'Transaction Fees',
                    vatAmount: item.transactionFeeTax,
                    baseAmount: item.transactionFeeWithTax,
                  },
                ]
              : []),
          ]}
          columnTemplate={'1fr 1fr 1fr 1fr 50px'}
          isLoading={isTransactionLoading}
          loadingRowCount={3}
          tableVariant={'main'}
          tableOverflow={'normal'}
        />
        <div className='transaction__total'>Total inc GST: {currencyFormat(item.netAmount)}</div>
      </Panel>
    </div>
  );
};

export default TransactionsModalContent;
